import { Validators } from "@angular/forms";
import { FormField } from "./form-field.model";

export const INVITE_LEARNER_FORM: { [key: string]: FormField } = {
    fiscalCode: {
        id: 'fiscalCode',
        type: 'text',
        name: 'fiscalCode',
        label: 'Codice fiscale',
        placeholder: "Codice fiscale",
        value: '',
        data: [],
        validators: [],
        errorMessages: {
        },
        toUppercase: true
    },
    email: {
        id: 'email',
        type: 'email',
        name: 'email',
        label: 'Email',
        placeholder: "Email",
        value: '',
        data: [],
        validators: [Validators.required, Validators.email],
        errorMessages: {
            required: "Inserire l'email.",
            email: "Inserire un'email valida."
        }
    }
}